import { configureStore } from "@reduxjs/toolkit"
import locationReducer from "./locationReducer"
import tesisReducer from "./tesisReducer"
import userReducer from "./userReducer"

const store = configureStore({
  reducer: {
    location: locationReducer,
    tesis: tesisReducer,
    user: userReducer,
  },
})

export default store
